/* src/app/modules/spare-parts/spare-parts-filter-popover/spare-parts-filter-popover.component.scss */
:host {
  display: block;
}
.clear-all-btn {
  width: fit-content;
  padding: 0;
  font: var(--body-1);
  line-height: 1.7rem;
  text-decoration-line: underline;
  border: none;
  color: rgba(0, 0, 0, 0.6);
  background-color: transparent;
  cursor: pointer;
}
/*# sourceMappingURL=spare-parts-filter-popover.component.css.map */
